import { Check, X } from "lucide-react";
import { hasRole } from "@/context/AuthContext";

export function TypeBadge({ user }) {
  if (user.user_type === "staff" && hasRole(user, "network_owner")) {
    return (
      <span data-testid="badge-network-owner" className="bz-badge border-purple-500/30 bg-purple-500/15 font-semibold tracking-wide text-purple-200">
        Network Owner
      </span>
    );
  }
  if (user.user_type === "staff") {
    const role = user.roles?.[0] ?? user.staff_role;
    return (
      <span data-testid="badge-staff" className="bz-badge border-blue-500/30 bg-blue-500/15 text-blue-200">
        Staff{role ? ` · ${role.replace(/_/g, " ")}` : ""}
      </span>
    );
  }
  return (
    <span data-testid="badge-customer" className="bz-badge border-slate-500/30 bg-slate-500/15 text-slate-200">
      Customer
    </span>
  );
}

export function BoolBadge({ value, yes = "Yes", no = "No", testId }) {
  return value ? (
    <span data-testid={testId} className="bz-badge border-emerald-500/30 bg-emerald-500/12 text-emerald-200">
      <Check className="h-3 w-3" strokeWidth={2.5} /> {yes}
    </span>
  ) : (
    <span data-testid={testId} className="bz-badge border-white/10 bg-white/5 text-slate-400">
      <X className="h-3 w-3" strokeWidth={2.5} /> {no}
    </span>
  );
}

export function OutcomeBadge({ outcome }) {
  return outcome === "success" ? (
    <span className="bz-badge border-emerald-500/30 bg-emerald-500/12 text-emerald-200">success</span>
  ) : (
    <span className="bz-badge border-red-500/30 bg-red-500/12 text-red-200">failure</span>
  );
}

export function FixtureBadge({ user }) {
  if (!user?.is_fixture) return null;
  return (
    <span data-testid="badge-fixture" className="bz-badge border-amber-500/30 bg-amber-500/12 text-amber-200">
      TEST fixture
    </span>
  );
}
